import { useMutation } from "react-query";
import { runApplication } from "../APIs/ggs";

const useLocalApp = () => {
  const { mutate: runApplicationMutation } = useMutation("start-app", runApplication);

  const runApp = (id) => {
    runApplicationMutation(id, {
      onSuccess: (a) => {
        console.log("Success", a);
      },
      onError: (err) => console.log("Error", err),
    });
  };

  return { runApp };
};

export default useLocalApp;
